import(/* webpackMode: "eager" */ "C:\\MyGit\\OKNET_SE\\oknet_react\\app\\page.tsx");
